const baseUrl = '/bills';
export const billsRoutes = {
  baseUrl: "".concat(baseUrl),
  billSettings: "".concat(baseUrl, "/bill-settings"),
  billSettingsV2: "".concat(baseUrl, "/bill-settings-v2"),
  /** Keyed on the push attempt, not the bill: the accounts belong to one attempt's payload. */
  pushGlAccounts: pushAttemptId => "".concat(baseUrl, "/").concat(pushAttemptId, "/gl-accounts")
};